"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByPath = exports.mergeDeep = exports.isObject = void 0;
function isObject(item) {
    return (item && typeof item === 'object');
}
exports.isObject = isObject;
function mergeDeep(...objects) {
    return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach((key) => {
            const pVal = prev[key];
            const oVal = obj[key];
            if (Array.isArray(pVal) && Array.isArray(oVal)) {
                prev[key] = pVal.concat(...oVal);
            }
            else if (isObject(pVal) && isObject(oVal)) {
                prev[key] = mergeDeep(pVal, oVal);
            }
            else {
                prev[key] = oVal;
            }
        });
        return prev;
    }, {});
}
exports.mergeDeep = mergeDeep;
const getByPath = (object, path) => {
    if (object == null) { // null or undefined
        return object;
    }
    const parts = path.split('.');
    return parts.reduce((obj, key) => obj === null || obj === void 0 ? void 0 : obj[key], object);
};
exports.getByPath = getByPath;
//# sourceMappingURL=base.js.map